<div class="card mt-3">
    <div class="card-body">
      <div *ngIf="titulo" class="row">
        <div class="col">
          <h4>{{ titulo }}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
  